import Verify2FA from "./Verify2FA";

export default Verify2FA;
